import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {
    checkIsUpdateInstruction,
    editDataInstruction,
    getAllDevicesByInstallationId,
    getAllLocationItem,
    getAllLocationsByInstallationId,
    getLocations,
    idMOdal,
    modalVisibilityTriggerInstruction
} from "../../redux-store/selectors";
import {createNewInstruction, hideModalTriggerUpdate, updateInstructionItem} from "../../redux-store/triggers";
import {Select} from "antd";
import api from "../../api/apiInterceptor";

const {Option} = Select
const defaultValues = {"deviceId": "", "methodName": "", "arguments": []}

const UpdateInstructionModal = ({installationId, eventKey}) => {
    const {
        register,
        handleSubmit,
        formState: {isSubmitSuccessful},
        setValue,
        reset,
        watch,
        control
    } = useForm();
    const dispatch = useDispatch();
    const modalStatus = useSelector(modalVisibilityTriggerInstruction)
    const idModalUpdate = useSelector(idMOdal)
    const editItemInstruction = useSelector(editDataInstruction)
    const checkIsUpdateForm = useSelector(checkIsUpdateInstruction)
    const methodeForDevice = watch("deviceId");
    const allDevices = useSelector(getAllDevicesByInstallationId);
    const getAllLocations = useSelector(getAllLocationItem)

    const [commandProducersOptions, setCommandProducersOptions] = useState([])
    const [instructionOption, setInstructionOption] = useState([]);
    const [classNameForMethode, setClassNameForMethode] = useState([]);
    const [arrayMethodeForDevice, setArrayMethodeForDevice] = useState([])

    useEffect(() => {
        if (editItemInstruction !== undefined && Object.entries(editItemInstruction).length > 0) {
            setValue("deviceId", editItemInstruction.deviceId)
            setValue("methodName", editItemInstruction.methodName)
            setValue("arguments", JSON.stringify(editItemInstruction.arguments).slice(1,-1))
        }
    }, [editItemInstruction]);

    useEffect(() => {
        if (isSubmitSuccessful) {
            reset(defaultValues)
        }
    }, [isSubmitSuccessful])


    useEffect(() => {
        if (eventKey) {
            deviceAndLocationSelectOption();
            assembleSelects();
        }
    }, [eventKey]);

    useEffect(() => {
        const filterDeviceForMethode = instructionOption.filter((item => item.id === methodeForDevice))
        const classNameForMethode = filterDeviceForMethode.map(item => item.className)
        setClassNameForMethode(classNameForMethode[0])
    },[methodeForDevice])

    useEffect(() => {
        const methodeOption = arrayMethodeForDevice.filter(item => item.className === classNameForMethode)
        const commandProducers = []

        methodeOption.map((device) => {
            commandProducers.push(...device.commandProducers)
        })

        setCommandProducersOptions(commandProducers)

    }, [classNameForMethode]);


    const handleSubmitForm = (data, e) => {
        e.preventDefault()
        if (checkIsUpdateForm) {
            if (data.arguments) data.arguments = JSON.parse("[" + data.arguments + "]");
            else data.arguments = [];
            dispatch(updateInstructionItem({
                installationId: installationId,
                triggerItemId: eventKey,
                idForUpdate: idModalUpdate,
                data: data
            }))
        } else {
            if (data.arguments) data.arguments = JSON.parse("[" + data.arguments + "]");
            else data.arguments = [];
            dispatch(createNewInstruction({
                installationId: installationId,
                triggerItemId: eventKey,
                data: data
            }))
        }
    }


    const assembleSelects = async () => {
        let results = await api.get("/api/devicetypes")

        setArrayMethodeForDevice(results.data)
    }

    const deviceAndLocationSelectOption = () => {
        const optionSelect = allDevices.map(itm => ({
            ...getAllLocations.find((item) => (item.id === itm.locationId) && item),
            ...itm
        }));
        setInstructionOption(optionSelect)
    }

    const handleCloseModal = () => {
        dispatch(hideModalTriggerUpdate())
        reset(defaultValues);
    }

    return (
        <>
            <Modal
                show={modalStatus}
                onHide={handleCloseModal}
                backdrop="static"
                keyboard={false}
                size={"lg"}
            >
                <Modal.Header closeButton className={"modal-header-component"}>
                    <Modal.Title>{"Instrukcija"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(handleSubmitForm)}>
                        <div className="mb-4">
                            <label className="mb-2 form-label" htmlFor="deviceId">Uređaji</label>
                            <Controller
                                control={control}
                                name={"deviceId"}
                                render={({
                                             field: {onChange, value, ref},
                                         }) => (<Select
                                    onChange={onChange}
                                    value={value}
                                    ref={ref}
                                    className={"form-select"}
                                    getPopupContainer={node => node.parentNode}
                                    defaultValue={editItemInstruction.deviceId}
                                >
                                    {instructionOption.map((item,key) => {
                                       return <Option key={item.id} value={item.id}>{`${item.model}#${item.id} @${item.name ? item.name : ""}`}</Option>
                                    })}
                                </Select>)}
                                rules={{required: true}}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="mb-2 form-label" htmlFor="methodName">Ime metode</label>
                            <Controller
                                control={control}
                                name={"methodName"}
                                render={({
                                             field: {onChange, value, ref},
                                         }) => (<Select
                                    onChange={onChange}
                                    value={value}
                                    ref={ref}
                                    className={"form-select"}
                                    getPopupContainer={node => node.parentNode}
                                    defaultValue={editItemInstruction.methodName}
                                >
                                    {commandProducersOptions.map((item,key) => {
                                        return <Option key={item.id} value={item}>{item}</Option>
                                    })}
                                </Select>)}
                                rules={{required: true}}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="mb-2 form-label" htmlFor="arguments">Argumenti</label>
                            <input type="text"
                                   className="form-control"
                                   name={["arguments"]}
                                   {...register("arguments")}/>
                        </div>
                        <div className={"modal-footer-component"}>
                            <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                                {"Otkaži"}
                            </button>
                            <button
                                className={"btn btn-modal-confirm"}>{checkIsUpdateForm ? "Ažuriraj" : "Kreiraj"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default UpdateInstructionModal;
